var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['tw:p-4 tw:xl:p-8 tw:bg-white tw:rounded-2xl', _setup.props.classNames]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }